// ---------------------- NETWORK DASHBOARD CONSTANTS ---------------------------

import { IRealtimeAnalytics } from '~/src/dash/api/console-api';
import { IGraphDataTypes } from '~/src/dash/components/dashboard/dashboard-graph';
import {
  DensityRange1HourByMinutes,
  DensityRange4HoursByHour,
  DensityRange4HoursByMinutes,
  DensityRange12HoursByHour,
  DensityRange15Minutes,
  DensityRange24HoursByHour,
  DensityRange30Minutes,
  IDensityRange,
  ISelectedMetric,
} from '~/src/dash/globals/constants';
import { IMenuList } from '~/src/dash/types/menuList';
import { LoadingState } from '~/src/dash/utils/loading-states';

export const networkHomeAggDataTitles = {
  AGG_STREAM_ADS_FILLED_TITLE: 'Ads Filled',
  AGG_STREAM_POD_REQUESTS_TITLE: 'Pod Requests',
  AGG_STREAM_STREAM_ERROR_TITLE: 'Stream Error',
  AGG_STREAM_PODS_FILLED_TITLE: 'Pods Filled',
  AGG_STREAM_AD_IMPRESSIONS_TITLE: 'Impressions',
  AGG_STREAM_AVG_STREAM_AD_FILL_LATENCY_TITLE: 'Fill Latency',
  AGG_STREAM_ADS_FETCH_TIMEOUT_TITLE: 'Fetch Timeout',
  AGG_STREAM_CHUNKLIST_FETCH_TITLE: 'Chunklist Fetch',
  AGG_STREAM_CHUNKLIST_RESPONSE_TITLE: 'Chunklist Response',
  AGG_STREAM_START_TITLE: 'Stream Start',
  AGG_STREAM_PLAYLIST_TIMEOUT_TITLE: 'Playlist Timeout',
  AGG_STREAM_ERROR_TITLE: 'Stream Error',
};
export const networkHomeAggDataKeys = {
  AGG_ADS_FILLED_KEY: 'AdFilled',
  AGG_POD_REQUESTS_KEY: 'PodRequest',
  AGG_PODS_FILLED_KEY: 'PodFilled',
  AGG_AD_IMPRESSIONS_KEY: 'AdImpression',
  AGG_AVG_STREAM_AD_FILLED_LATENCY_KEY: 'AvgStreamAdFilledLatency',
  AGG_STREAM_AD_COMPLETE_KEY: 'StreamAdComplete',
  AGG_STREAM_AD_FILLED_KEY: 'StreamAdFilled',
  AGG_STREAM_AD_IMPRESSION_KEY: 'StreamAdImpression',
  AGG_STREAM_ADS_FETCH_TIMEOUT_KEY: 'StreamAdsFetchTimeout',
  AGG_STREAM_CHUNKLIST_FETCH_KEY: 'StreamChunklistFetch',
  AGG_STREAM_CHUNKLIST_RESPONSE_KEY: 'StreamAdChunklistResponse',
  AGG_STREAM_ERROR_KEY: 'StreamError',
  AGG_STREAM_PLAYLIST_TIMEOUT_KEY: 'StreamPlaylistTimeout',
  AGG_STREAM_POD_REQUEST_KEY: 'StreamPodRequest',
  AGG_STREAM_START_KEY: 'StreamStart',
};
export const networkHomeAggDataComparisonKeys = {
  AGG_ADS_FILLED_COMPARE_KEY: 'CompareAdsFilled',
  AGG_POD_REQUESTS_COMPARE_KEY: 'ComparePodRequests',
  AGG_STREAM_ERROR_COMPARE_KEY: 'CompareStreamError',
  AGG_PODS_FILLED_COMPARE_KEY: 'ComparePodsFilled',
  AGG_AD_IMPRESSIONS_COMPARE_KEY: 'CompareAdImpressions',
  AGG_AVG_STREAM_AD_FILLED_LATENCY_COMPARE_KEY: 'CompareAvgStreamAdFilledLatency',
  AGG_STREAM_ADS_FETCH_TIMEOUT_COMPARE_KEY: 'CompareAdsFetchTimeout',
  AGG_STREAM_CHUNKLIST_FETCH_COMPARE_KEY: 'CompareStreamChunklistFetch',
  AGG_STREAM_CHUNKLIST_RESPONSE_COMPARE_KEY: 'CompareStreamAdChunklistResponse',
  AGG_STREAM_START_COMPARE_KEY: 'CompareStreamStart',
  AGG_STREAM_PLAYLIST_TIMEOUT_COMPARE_KEY: 'CompareStreamPlaylistTimeout',
};
export const networkHomeLiveDataTitles = {
  STREAM_AD_FILLED_TITLE: 'Ads Filled',
  STREAM_POD_REQUEST_TITLE: 'Pod Requests',
  STREAM_POD_FILLED_TITLE: 'Pods Filled',
  STREAM_AD_IMPRESSION_TITLE: 'Ad Impressions',
  STREAM_AD_COMPLETE_TITLE: 'Ad Complete',
  STREAM_AD_FETCH_TIMEOUT_TITLE: 'Ad Fetch Timeout',
  STREAM_CHUNKLIST_FETCH_TITLE: 'Chunklist Fetch',
  STREAM_CHUNKLIST_RESPONSE_TITLE: 'Chunklist Response',
  STREAM_ERROR_TITLE: 'Stream Error',
  STREAM_PLAYLIST_TIMEOUT_TITLE: 'Playlist Timeout',
  STREAM_START_TITLE: 'Stream Start',
  STREAM_AD_CHUNKLIST_FETCH_TITLE: 'Ad Chunklist Fetch',
  STREAM_AD_CHUNKLIST_RESPONSE_TITLE: 'Ad Chunklist Response',
  STREAM_AD_FILLED_LATENCY_TITLE: 'Ad Filled Latency',
  STREAM_FETCH_TIMEOUT_TITLE: 'Fetch Timeout',
  STREAM_CHUNKLIST_TIMEOUT_TITLE: 'Chunklist Timeout',
  STREAM_TRANSCODE_MISS_TITLE: 'Transcode Miss',
  STREAM_TRANSCODE_MISS_ERROR_TITLE: 'Transcode Miss Error',
  STREAM_CACHED_AD_MISS_TITLE: 'Cached Ad Miss',
  STREAM_ADS_FETCH_ERROR_TITLE: 'Ads Fetch Error',
  STREAM_PLAYLIST_ERROR_TITLE: 'Playlist Error',
  STREAM_CHUNKLIST_ERROR_TITLE: 'Chunklist Error',
  STREAM_CACHE_READ_MISS_ERROR_TITLE: 'Cache Read Miss Error',
};
export const networkHomeLiveDataKeys = {
  STREAM_AD_FILLED_KEY: 'StreamAdFilled',
  STREAM_POD_REQUEST_KEY: 'StreamPodRequest',
  STREAM_POD_FILLED_KEY: 'StreamPodFilled',
  STREAM_AD_IMPRESSION_KEY: 'StreamAdImpression',
  STREAM_AD_COMPLETE_KEY: 'StreamAdComplete',
  STREAM_AD_FETCH_TIMEOUT_KEY: 'StreamAdFetchTimeout',
  STREAM_CHUNKLIST_FETCH_KEY: 'StreamChunklistFetch',
  STREAM_CHUNKLIST_RESPONSE_KEY: 'StreamChunklistResponse',
  STREAM_ERROR_KEY: 'StreamError',
  STREAM_PLAYLIST_TIMEOUT_KEY: 'StreamPlaylistTimeout',
  STREAM_START_KEY: 'StreamStart',
  STREAM_AD_CHUNKLIST_FETCH_KEY: 'StreamAdChunklistFetch',
  STREAM_AD_CHUNKLIST_RESPONSE_KEY: 'StreamAdChunklistResponse',
  STREAM_AD_FILLED_LATENCY_KEY: 'StreamAdFilledLatency',
  STREAM_FETCH_TIMEOUT_KEY: 'StreamFetchTimeout',
  STREAM_CHUNKLIST_TIMEOUT_KEY: 'StreamChunklistTimeout',
  STREAM_TRANSCODE_MISS_KEY: 'StreamTranscodeMiss',
  STREAM_TRANSCODE_MISS_ERROR_KEY: 'StreamTranscodeMissError',
  STREAM_CACHED_AD_MISS_KEY: 'StreamCachedAdMiss',
  STREAM_ADS_FETCH_ERROR_KEY: 'StreamAdsFetchError',
  STREAM_PLAYLIST_ERROR_KEY: 'StreamPlaylistError',
  STREAM_CHUNKLIST_ERROR_KEY: 'StreamChunklistError',
  STREAM_CACHE_READ_MISS_ERROR_KEY: 'StreamCacheReadMissError',
};

export const streamEventTypeNumberToName = {
  Unknown: ['FORMAT_UNDEFINED'],
  'Empty String': ['FORMAT_UNDEFINED'],
  '1': ['HLS_LIVE', 'DASH_LIVE'],
  '2': ['HLS_VOD', 'DASH_VOD'],
  '3': ['JIT_VOD'],
} as { [key: string]: string[] };

const {
  AGG_STREAM_ADS_FILLED_TITLE,
  AGG_STREAM_POD_REQUESTS_TITLE,
  AGG_STREAM_STREAM_ERROR_TITLE,
  AGG_STREAM_PODS_FILLED_TITLE,
  AGG_STREAM_AD_IMPRESSIONS_TITLE,
  AGG_STREAM_AVG_STREAM_AD_FILL_LATENCY_TITLE,
  AGG_STREAM_ADS_FETCH_TIMEOUT_TITLE,
  AGG_STREAM_CHUNKLIST_FETCH_TITLE,
  AGG_STREAM_CHUNKLIST_RESPONSE_TITLE,
  AGG_STREAM_START_TITLE,
  AGG_STREAM_PLAYLIST_TIMEOUT_TITLE,
  AGG_STREAM_ERROR_TITLE,
} = networkHomeAggDataTitles;

const {
  AGG_ADS_FILLED_KEY,
  AGG_POD_REQUESTS_KEY,
  AGG_PODS_FILLED_KEY,
  AGG_AD_IMPRESSIONS_KEY,
  AGG_AVG_STREAM_AD_FILLED_LATENCY_KEY,
  AGG_STREAM_ADS_FETCH_TIMEOUT_KEY,
  AGG_STREAM_CHUNKLIST_FETCH_KEY,
  AGG_STREAM_CHUNKLIST_RESPONSE_KEY,
  AGG_STREAM_ERROR_KEY,
  AGG_STREAM_PLAYLIST_TIMEOUT_KEY,
  AGG_STREAM_START_KEY,
} = networkHomeAggDataKeys;

const {
  AGG_ADS_FILLED_COMPARE_KEY,
  AGG_POD_REQUESTS_COMPARE_KEY,
  AGG_STREAM_ERROR_COMPARE_KEY,
  AGG_PODS_FILLED_COMPARE_KEY,
  AGG_AD_IMPRESSIONS_COMPARE_KEY,
  AGG_AVG_STREAM_AD_FILLED_LATENCY_COMPARE_KEY,
  AGG_STREAM_ADS_FETCH_TIMEOUT_COMPARE_KEY,
  AGG_STREAM_CHUNKLIST_FETCH_COMPARE_KEY,
  AGG_STREAM_CHUNKLIST_RESPONSE_COMPARE_KEY,
  AGG_STREAM_START_COMPARE_KEY,
  AGG_STREAM_PLAYLIST_TIMEOUT_COMPARE_KEY,
} = networkHomeAggDataComparisonKeys;

const {
  STREAM_AD_FILLED_KEY,
  STREAM_POD_REQUEST_KEY,
  STREAM_POD_FILLED_KEY,
  STREAM_AD_IMPRESSION_KEY,
  STREAM_AD_COMPLETE_KEY,
  STREAM_CHUNKLIST_FETCH_KEY,
  STREAM_CHUNKLIST_RESPONSE_KEY,
  STREAM_PLAYLIST_TIMEOUT_KEY,
  STREAM_START_KEY,
  STREAM_AD_FILLED_LATENCY_KEY,
  STREAM_AD_FETCH_TIMEOUT_KEY,
  STREAM_CHUNKLIST_TIMEOUT_KEY,
  STREAM_TRANSCODE_MISS_ERROR_KEY,
  STREAM_CACHED_AD_MISS_KEY,
  STREAM_ADS_FETCH_ERROR_KEY,
  STREAM_PLAYLIST_ERROR_KEY,
  STREAM_CHUNKLIST_ERROR_KEY,
  STREAM_CACHE_READ_MISS_ERROR_KEY,
  STREAM_ERROR_KEY,
  STREAM_AD_CHUNKLIST_FETCH_KEY,
  STREAM_AD_CHUNKLIST_RESPONSE_KEY,
  STREAM_FETCH_TIMEOUT_KEY,
  STREAM_TRANSCODE_MISS_KEY,
} = networkHomeLiveDataKeys;

const {
  STREAM_AD_FILLED_TITLE,
  STREAM_POD_REQUEST_TITLE,
  STREAM_POD_FILLED_TITLE,
  STREAM_AD_IMPRESSION_TITLE,
  STREAM_AD_COMPLETE_TITLE,
  STREAM_CHUNKLIST_FETCH_TITLE,
  STREAM_CHUNKLIST_RESPONSE_TITLE,
  STREAM_PLAYLIST_TIMEOUT_TITLE,
  STREAM_START_TITLE,
  STREAM_AD_FILLED_LATENCY_TITLE,
  STREAM_AD_FETCH_TIMEOUT_TITLE,
  STREAM_CHUNKLIST_TIMEOUT_TITLE,
  STREAM_TRANSCODE_MISS_ERROR_TITLE,
  STREAM_CACHED_AD_MISS_TITLE,
  STREAM_ADS_FETCH_ERROR_TITLE,
  STREAM_PLAYLIST_ERROR_TITLE,
  STREAM_CHUNKLIST_ERROR_TITLE,
  STREAM_CACHE_READ_MISS_ERROR_TITLE,
  STREAM_ERROR_TITLE,
  STREAM_AD_CHUNKLIST_FETCH_TITLE,
  STREAM_AD_CHUNKLIST_RESPONSE_TITLE,
  STREAM_FETCH_TIMEOUT_TITLE,
  STREAM_TRANSCODE_MISS_TITLE,
} = networkHomeLiveDataTitles;

export const networkHomeKeysToTitlesMapping = {
  [AGG_ADS_FILLED_KEY]: AGG_STREAM_ADS_FILLED_TITLE,
  [AGG_ADS_FILLED_COMPARE_KEY]: AGG_STREAM_ADS_FILLED_TITLE,
  [AGG_POD_REQUESTS_KEY]: AGG_STREAM_POD_REQUESTS_TITLE,
  [AGG_POD_REQUESTS_COMPARE_KEY]: AGG_STREAM_POD_REQUESTS_TITLE,
  [AGG_STREAM_ERROR_KEY]: AGG_STREAM_ERROR_TITLE,
  [AGG_STREAM_ERROR_COMPARE_KEY]: AGG_STREAM_ERROR_TITLE,
  [AGG_PODS_FILLED_KEY]: AGG_STREAM_PODS_FILLED_TITLE,
  [AGG_PODS_FILLED_COMPARE_KEY]: AGG_STREAM_PODS_FILLED_TITLE,
  [AGG_AD_IMPRESSIONS_KEY]: AGG_STREAM_AD_IMPRESSIONS_TITLE,
  [AGG_AD_IMPRESSIONS_COMPARE_KEY]: AGG_STREAM_AD_IMPRESSIONS_TITLE,
  [AGG_AVG_STREAM_AD_FILLED_LATENCY_KEY]: AGG_STREAM_AVG_STREAM_AD_FILL_LATENCY_TITLE,
  [AGG_AVG_STREAM_AD_FILLED_LATENCY_COMPARE_KEY]: AGG_STREAM_AVG_STREAM_AD_FILL_LATENCY_TITLE,
  [AGG_STREAM_ADS_FETCH_TIMEOUT_KEY]: AGG_STREAM_ADS_FETCH_TIMEOUT_TITLE,
  [AGG_STREAM_ADS_FETCH_TIMEOUT_COMPARE_KEY]: AGG_STREAM_ADS_FETCH_TIMEOUT_TITLE,
  [AGG_STREAM_CHUNKLIST_FETCH_KEY]: AGG_STREAM_CHUNKLIST_FETCH_TITLE,
  [AGG_STREAM_CHUNKLIST_FETCH_COMPARE_KEY]: AGG_STREAM_CHUNKLIST_FETCH_TITLE,
  [AGG_STREAM_CHUNKLIST_RESPONSE_KEY]: AGG_STREAM_CHUNKLIST_RESPONSE_TITLE,
  [AGG_STREAM_CHUNKLIST_RESPONSE_COMPARE_KEY]: AGG_STREAM_CHUNKLIST_RESPONSE_TITLE,
  [AGG_STREAM_START_KEY]: AGG_STREAM_START_TITLE,
  [AGG_STREAM_START_COMPARE_KEY]: AGG_STREAM_START_TITLE,
  [AGG_STREAM_PLAYLIST_TIMEOUT_KEY]: AGG_STREAM_PLAYLIST_TIMEOUT_TITLE,
  [AGG_STREAM_PLAYLIST_TIMEOUT_COMPARE_KEY]: AGG_STREAM_PLAYLIST_TIMEOUT_TITLE,
  [STREAM_AD_FILLED_KEY]: STREAM_AD_FILLED_TITLE,
  [STREAM_POD_REQUEST_KEY]: STREAM_POD_REQUEST_TITLE,
  [STREAM_POD_FILLED_KEY]: STREAM_POD_FILLED_TITLE,
  [STREAM_AD_IMPRESSION_KEY]: STREAM_AD_IMPRESSION_TITLE,
  [STREAM_AD_COMPLETE_KEY]: STREAM_AD_COMPLETE_TITLE,
  [STREAM_CHUNKLIST_FETCH_KEY]: STREAM_CHUNKLIST_FETCH_TITLE,
  [STREAM_CHUNKLIST_RESPONSE_KEY]: STREAM_CHUNKLIST_RESPONSE_TITLE,
  [STREAM_PLAYLIST_TIMEOUT_KEY]: STREAM_PLAYLIST_TIMEOUT_TITLE,
  [STREAM_START_KEY]: STREAM_START_TITLE,
  [STREAM_AD_FILLED_LATENCY_KEY]: STREAM_AD_FILLED_LATENCY_TITLE,
  [STREAM_AD_FETCH_TIMEOUT_KEY]: STREAM_AD_FETCH_TIMEOUT_TITLE,
  [STREAM_CHUNKLIST_TIMEOUT_KEY]: STREAM_CHUNKLIST_TIMEOUT_TITLE,
  [STREAM_TRANSCODE_MISS_ERROR_KEY]: STREAM_TRANSCODE_MISS_ERROR_TITLE,
  [STREAM_CACHED_AD_MISS_KEY]: STREAM_CACHED_AD_MISS_TITLE,
  [STREAM_ADS_FETCH_ERROR_KEY]: STREAM_ADS_FETCH_ERROR_TITLE,
  [STREAM_PLAYLIST_ERROR_KEY]: STREAM_PLAYLIST_ERROR_TITLE,
  [STREAM_CHUNKLIST_ERROR_KEY]: STREAM_CHUNKLIST_ERROR_TITLE,
  [STREAM_CACHE_READ_MISS_ERROR_KEY]: STREAM_CACHE_READ_MISS_ERROR_TITLE,
} as Record<string, StreamDashboardCardDataTitles>;

export const networkHomeTitlesToKeysMapping = {
  [STREAM_AD_FILLED_TITLE]: STREAM_AD_FILLED_KEY,
  [STREAM_POD_REQUEST_TITLE]: STREAM_POD_REQUEST_KEY,
  [STREAM_POD_FILLED_TITLE]: STREAM_POD_FILLED_KEY,
  [STREAM_AD_IMPRESSION_TITLE]: STREAM_AD_IMPRESSION_KEY,
  [STREAM_AD_COMPLETE_TITLE]: STREAM_AD_COMPLETE_KEY,
  [STREAM_AD_FETCH_TIMEOUT_TITLE]: STREAM_AD_FETCH_TIMEOUT_KEY,
  [STREAM_CHUNKLIST_FETCH_TITLE]: STREAM_CHUNKLIST_FETCH_KEY,
  [STREAM_CHUNKLIST_RESPONSE_TITLE]: STREAM_CHUNKLIST_RESPONSE_KEY,
  [STREAM_ERROR_TITLE]: STREAM_ERROR_KEY,
  [STREAM_PLAYLIST_TIMEOUT_TITLE]: STREAM_PLAYLIST_TIMEOUT_KEY,
  [STREAM_START_TITLE]: STREAM_START_KEY,
  [STREAM_AD_CHUNKLIST_FETCH_TITLE]: STREAM_AD_CHUNKLIST_FETCH_KEY,
  [STREAM_AD_CHUNKLIST_RESPONSE_TITLE]: STREAM_AD_CHUNKLIST_RESPONSE_KEY,
  [STREAM_AD_FILLED_LATENCY_TITLE]: STREAM_AD_FILLED_LATENCY_KEY,
  [STREAM_FETCH_TIMEOUT_TITLE]: STREAM_FETCH_TIMEOUT_KEY,
  [STREAM_CHUNKLIST_TIMEOUT_TITLE]: STREAM_CHUNKLIST_TIMEOUT_KEY,
  [STREAM_TRANSCODE_MISS_TITLE]: STREAM_TRANSCODE_MISS_KEY,
  [STREAM_TRANSCODE_MISS_ERROR_TITLE]: STREAM_TRANSCODE_MISS_ERROR_KEY,
  [STREAM_CACHED_AD_MISS_TITLE]: STREAM_CACHED_AD_MISS_KEY,
  [STREAM_ADS_FETCH_ERROR_TITLE]: STREAM_ADS_FETCH_ERROR_KEY,
  [STREAM_PLAYLIST_ERROR_TITLE]: STREAM_PLAYLIST_ERROR_KEY,
  [STREAM_CHUNKLIST_ERROR_TITLE]: STREAM_CHUNKLIST_ERROR_KEY,
  [STREAM_CACHE_READ_MISS_ERROR_TITLE]: STREAM_CACHE_READ_MISS_ERROR_KEY,
} as Record<string, StreamDashboardCardDataKeys | StreamDashboardCardDataCompareKeys>;

// Controls which metrics are active by default
export const selectedMetricsOverview = [
  { key: AGG_STREAM_POD_REQUESTS_TITLE, active: true },
  { key: AGG_STREAM_ADS_FILLED_TITLE, active: true },
  { key: AGG_STREAM_AD_IMPRESSIONS_TITLE, active: true },
  { key: AGG_STREAM_PODS_FILLED_TITLE, active: false },
  { key: AGG_STREAM_AVG_STREAM_AD_FILL_LATENCY_TITLE, active: false },
  { key: AGG_STREAM_ADS_FETCH_TIMEOUT_TITLE, active: false },
];
export const selectedMetricsKPI = [
  { key: STREAM_START_TITLE, active: true },
  { key: STREAM_AD_FILLED_TITLE, active: false },
  { key: STREAM_POD_REQUEST_TITLE, active: false },
  { key: STREAM_AD_COMPLETE_TITLE, active: false },
  { key: STREAM_POD_FILLED_TITLE, active: false },
  { key: STREAM_AD_IMPRESSION_TITLE, active: false },
  { key: STREAM_CHUNKLIST_FETCH_TITLE, active: false },
  { key: STREAM_CHUNKLIST_RESPONSE_TITLE, active: false },
];
export const selectedMetricsLatency = [
  { key: STREAM_CHUNKLIST_TIMEOUT_TITLE, active: true },
  { key: STREAM_PLAYLIST_TIMEOUT_TITLE, active: false },
  { key: STREAM_AD_FILLED_LATENCY_TITLE, active: false },
  { key: STREAM_AD_FETCH_TIMEOUT_TITLE, active: false },
];
export const selectedMetricsError = [
  { key: STREAM_TRANSCODE_MISS_ERROR_TITLE, active: false },
  { key: STREAM_CACHED_AD_MISS_TITLE, active: false },
  { key: STREAM_ADS_FETCH_ERROR_TITLE, active: false },
  { key: STREAM_PLAYLIST_ERROR_TITLE, active: false },
  { key: STREAM_CHUNKLIST_ERROR_TITLE, active: true },
  { key: STREAM_CACHE_READ_MISS_ERROR_TITLE, active: false },
];

// Controls the display color in the DashboardGraphsV2 component
export const liveKPIGraphData = {
  [STREAM_AD_FILLED_KEY]: { color: '#4FC1B5', title: STREAM_AD_FILLED_TITLE },
  [STREAM_POD_REQUEST_KEY]: { color: '#4FC1B5', title: STREAM_POD_REQUEST_TITLE },
  [STREAM_POD_FILLED_KEY]: { color: '#4FC1B5', title: STREAM_POD_FILLED_TITLE },
  [STREAM_AD_IMPRESSION_KEY]: { color: '#4FC1B5', title: STREAM_AD_IMPRESSION_TITLE },
  [STREAM_AD_COMPLETE_KEY]: { color: '#4FC1B5', title: STREAM_AD_COMPLETE_TITLE },
  [STREAM_CHUNKLIST_RESPONSE_KEY]: { color: '#4FC1B5', title: STREAM_CHUNKLIST_RESPONSE_TITLE },
  [STREAM_CHUNKLIST_FETCH_KEY]: { color: '#4FC1B5', title: STREAM_CHUNKLIST_FETCH_TITLE },
  [STREAM_AD_COMPLETE_KEY]: { color: '#4FC1B5', title: STREAM_AD_COMPLETE_TITLE },
  [STREAM_START_KEY]: { color: '#4FC1B5', title: STREAM_START_TITLE },
} as IGraphDataTypes;

export const liveLatencyGraphData = {
  [STREAM_AD_FILLED_LATENCY_KEY]: { color: '#DAD7FE', title: STREAM_AD_FILLED_LATENCY_TITLE },
  [STREAM_AD_FETCH_TIMEOUT_KEY]: { color: '#DAD7FE', title: STREAM_AD_FETCH_TIMEOUT_TITLE },
  [STREAM_PLAYLIST_TIMEOUT_KEY]: { color: '#DAD7FE', title: STREAM_PLAYLIST_TIMEOUT_TITLE },
  [STREAM_CHUNKLIST_TIMEOUT_KEY]: { color: '#DAD7FE', title: STREAM_CHUNKLIST_TIMEOUT_TITLE },
} as IGraphDataTypes;

export const liveErrorGraphData = {
  [STREAM_TRANSCODE_MISS_ERROR_KEY]: { color: '#F2397C', title: STREAM_TRANSCODE_MISS_ERROR_TITLE },
  [STREAM_CACHED_AD_MISS_KEY]: { color: '#F2397C', title: STREAM_CACHED_AD_MISS_TITLE },
  [STREAM_ADS_FETCH_ERROR_KEY]: { color: '#F2397C', title: STREAM_ADS_FETCH_ERROR_TITLE },
  [STREAM_PLAYLIST_ERROR_KEY]: { color: '#F2397C', title: STREAM_PLAYLIST_ERROR_TITLE },
  [STREAM_CHUNKLIST_ERROR_KEY]: { color: '#F2397C', title: STREAM_CHUNKLIST_ERROR_TITLE },
  [STREAM_CACHE_READ_MISS_ERROR_KEY]: {
    color: '#F2397C',
    title: STREAM_CACHE_READ_MISS_ERROR_TITLE,
  },
} as IGraphDataTypes;

// Controls bar generation in DashboardGraphsV2 component
export const cardDataDisplayOverview = {
  [AGG_STREAM_AD_IMPRESSIONS_TITLE]: {
    value: '',
    sign: 1,
    key: AGG_AD_IMPRESSIONS_KEY,
    compareKey: AGG_AD_IMPRESSIONS_COMPARE_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [AGG_STREAM_ADS_FETCH_TIMEOUT_TITLE]: {
    value: '',
    sign: 1,
    key: AGG_STREAM_ADS_FETCH_TIMEOUT_KEY,
    compareKey: AGG_STREAM_ADS_FETCH_TIMEOUT_COMPARE_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [AGG_STREAM_ADS_FILLED_TITLE]: {
    value: '',
    sign: 1,
    key: AGG_ADS_FILLED_KEY,
    compareKey: AGG_ADS_FILLED_COMPARE_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [AGG_STREAM_AVG_STREAM_AD_FILL_LATENCY_TITLE]: {
    value: '',
    sign: 1,
    key: AGG_AVG_STREAM_AD_FILLED_LATENCY_KEY,
    compareKey: AGG_AVG_STREAM_AD_FILLED_LATENCY_COMPARE_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [AGG_STREAM_POD_REQUESTS_TITLE]: {
    value: '',
    sign: 1,
    key: AGG_POD_REQUESTS_KEY,
    compareKey: AGG_POD_REQUESTS_COMPARE_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [AGG_STREAM_PODS_FILLED_TITLE]: {
    value: '',
    sign: 1,
    key: AGG_PODS_FILLED_KEY,
    compareKey: AGG_PODS_FILLED_COMPARE_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [AGG_STREAM_CHUNKLIST_FETCH_TITLE]: {
    value: '',
    sign: 1,
    key: AGG_STREAM_CHUNKLIST_FETCH_KEY,
    compareKey: AGG_STREAM_CHUNKLIST_FETCH_COMPARE_KEY,
    yAxisID: 'small',
    suffix: '',
  },
  [AGG_STREAM_CHUNKLIST_RESPONSE_TITLE]: {
    value: '',
    sign: 1,
    key: AGG_STREAM_CHUNKLIST_RESPONSE_KEY,
    compareKey: AGG_STREAM_CHUNKLIST_RESPONSE_COMPARE_KEY,
    yAxisID: 'small',
    suffix: '',
  },
  [AGG_STREAM_STREAM_ERROR_TITLE]: {
    value: '',
    sign: 1,
    key: AGG_STREAM_ERROR_KEY,
    compareKey: AGG_STREAM_ERROR_COMPARE_KEY,
    yAxisID: 'small',
    suffix: '',
  },
  [AGG_STREAM_PLAYLIST_TIMEOUT_TITLE]: {
    value: '',
    sign: 1,
    key: AGG_STREAM_PLAYLIST_TIMEOUT_KEY,
    compareKey: AGG_STREAM_PLAYLIST_TIMEOUT_COMPARE_KEY,
    yAxisID: 'small',
    suffix: '',
  },
  [AGG_STREAM_START_TITLE]: {
    value: '',
    sign: 1,
    key: AGG_STREAM_START_KEY,
    compareKey: AGG_STREAM_START_COMPARE_KEY,
    yAxisID: 'small',
    suffix: '',
  },
} as IStreamAggregateCardDataDisplay;

export const cardDataDisplayKPI = {
  [STREAM_AD_FILLED_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_AD_FILLED_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_POD_REQUEST_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_POD_REQUEST_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_POD_FILLED_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_POD_FILLED_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_AD_IMPRESSION_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_AD_IMPRESSION_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_CHUNKLIST_FETCH_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_CHUNKLIST_FETCH_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_CHUNKLIST_RESPONSE_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_CHUNKLIST_RESPONSE_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_AD_COMPLETE_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_AD_COMPLETE_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_START_TITLE]: { value: '', sign: 1, key: STREAM_START_KEY, yAxisID: 'big', suffix: '' },
} as IStreamKPICardDataDisplay;

export const cardDataDisplayLatency = {
  [STREAM_PLAYLIST_TIMEOUT_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_PLAYLIST_TIMEOUT_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_AD_FILLED_LATENCY_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_AD_FILLED_LATENCY_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_AD_FETCH_TIMEOUT_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_AD_FETCH_TIMEOUT_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_CHUNKLIST_TIMEOUT_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_CHUNKLIST_TIMEOUT_KEY,
    yAxisID: 'big',
    suffix: '',
  },
} as IStreamLatencyCardDataDisplay;

export const cardDataDisplayError = {
  [STREAM_TRANSCODE_MISS_ERROR_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_TRANSCODE_MISS_ERROR_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_CACHED_AD_MISS_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_CACHED_AD_MISS_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_ADS_FETCH_ERROR_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_ADS_FETCH_ERROR_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_PLAYLIST_ERROR_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_PLAYLIST_ERROR_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_CHUNKLIST_ERROR_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_CHUNKLIST_ERROR_KEY,
    yAxisID: 'big',
    suffix: '',
  },
  [STREAM_CACHE_READ_MISS_ERROR_TITLE]: {
    value: '',
    sign: 1,
    key: STREAM_CACHE_READ_MISS_ERROR_KEY,
    yAxisID: 'big',
    suffix: '',
  },
} as IStreamErrorCardDataDisplay;

export const cardDataOverview = {
  [AGG_STREAM_AD_IMPRESSIONS_TITLE]: 0,
  [AGG_STREAM_ADS_FETCH_TIMEOUT_TITLE]: 0,
  [AGG_STREAM_ADS_FILLED_TITLE]: 0,
  [AGG_STREAM_AVG_STREAM_AD_FILL_LATENCY_TITLE]: 0,
  [AGG_STREAM_POD_REQUESTS_TITLE]: 0,
  [AGG_STREAM_PODS_FILLED_TITLE]: 0,
  [AGG_STREAM_CHUNKLIST_FETCH_TITLE]: 0,
  [AGG_STREAM_CHUNKLIST_RESPONSE_TITLE]: 0,
  [AGG_STREAM_STREAM_ERROR_TITLE]: 0,
  [AGG_STREAM_PLAYLIST_TIMEOUT_TITLE]: 0,
  [AGG_STREAM_START_TITLE]: 0,
};

export const streamDashboardCardDropdownList = [
  AGG_STREAM_ADS_FILLED_TITLE,
  AGG_STREAM_POD_REQUESTS_TITLE,
  AGG_STREAM_STREAM_ERROR_TITLE,
  AGG_STREAM_PODS_FILLED_TITLE,
  AGG_STREAM_AD_IMPRESSIONS_TITLE,
  AGG_STREAM_AVG_STREAM_AD_FILL_LATENCY_TITLE,
  AGG_STREAM_ADS_FETCH_TIMEOUT_TITLE,
  AGG_STREAM_CHUNKLIST_FETCH_TITLE,
  AGG_STREAM_CHUNKLIST_RESPONSE_TITLE,
  AGG_STREAM_START_TITLE,
  AGG_STREAM_PLAYLIST_TIMEOUT_TITLE,
];

export const STREAM_KPI_QUERY_STRING = '22,26,27,29,31,32,38,65';
export const STREAM_LATENCY_QUERY_STRING = '27,28,30,34,36';
export const STREAM_ERROR_QUERY_STRING = '67,68,69,70,71,72';

export const selectedMetricsColorMap = {
  0: '#4FC1B5',
  1: '#4952FF',
  2: '#EFCC57',
  3: '#273653',
  4: '#D81159',
  5: '#B55DF5',
} as Record<string, string>;

export const liveKPIColorMap = {
  0: '#4FC1B5',
  1: '#4FC1B5',
  2: '#4FC1B5',
  3: '#4FC1B5',
  4: '#4FC1B5',
  5: '#4FC1B5',
  6: '#4FC1B5',
  7: '#4FC1B5',
} as Record<string, string>;

export const liveLatencyColorMap = {
  0: '#DAD7FE',
  1: '#DAD7FE',
  2: '#DAD7FE',
  3: '#DAD7FE',
} as Record<string, string>;

export const liveErrorColorMap = {
  0: '#F2397C',
  1: '#F2397C',
  2: '#F2397C',
  3: '#F2397C',
  4: '#F2397C',
  5: '#F2397C',
} as Record<string, string>;

export const liveDensityRangesNetworkHome: IDensityRange[] = [
  { text: '15 min', value: DensityRange15Minutes },
  { text: '30 min', value: DensityRange30Minutes },
  { text: '1 hr', value: DensityRange1HourByMinutes },
  { text: '4 hrs', value: DensityRange4HoursByMinutes },
  { text: '4 hrs by hr', value: DensityRange4HoursByHour },
  { text: '12 hrs by hr', value: DensityRange12HoursByHour },
  { text: '24 hrs by hr', value: DensityRange24HoursByHour },
];

// ---------------------- INTERFACES AND TYPES -----------------------------

export enum ViewMode {
  Overview = 0,
  LiveData,
}

export interface IStreamDashboardCardDataDisplayItem {
  value: string;
  sign: number;
  suffix: string;
  key: StreamDashboardCardDataTitles;
  compareKey: StreamDashboardCardDataCompareKeys;
  yAxisID: string;
}
export interface IDashboardGraphV2State {
  loading: LoadingState;
  selectedMetrics: ISelectedMetric[];
  data: IRealtimeAnalytics[];
  rawData: IRealtimeAnalytics[];
  cardDataDisplay:
    | IStreamAggregateCardDataDisplay
    | IStreamKPICardDataDisplay
    | IStreamLatencyCardDataDisplay
    | IStreamErrorCardDataDisplay;
}
export interface IFilterDimensionState {
  selected: string[];
  selectedAll: boolean;
  forceOpenList: boolean;
  typeList: IMenuList;
}

export type StreamAggregateDataTitles =
  | 'Ads Filled'
  | 'Pod Requests'
  | 'Stream Error'
  | 'Pods Filled'
  | 'Impressions'
  | 'Fill Latency'
  | 'Fetch Timeout'
  | 'Chunklist Fetch'
  | 'Chunklist Response'
  | 'Stream Start'
  | 'Playlist Timeout';
export type StreamKPIDataTitles =
  | 'Ads Filled'
  | 'Pod Requests'
  | 'Pods Filled'
  | 'Ad Impressions'
  | 'Chunklist Fetch'
  | 'Chunklist Response'
  | 'Stream Start';
export type StreamLatencyDataTitles =
  | 'Ad Filled Latency'
  | 'Fetch Timeout'
  | 'Playlist Timeout'
  | 'Chunklist Timeout';
export type StreamErrorDataTitles =
  | 'Transcode Miss Error'
  | 'Cached Ad Miss'
  | 'Ads Fetch Error'
  | 'Playlist Error'
  | 'Chunklist Error'
  | 'Cache Read Miss Error';

export type StreamAggregateDataKeys =
  | 'AdFilled'
  | 'PodRequest'
  | 'PodFilled'
  | 'AdImpression'
  | 'AvgStreamAdFilledLatency'
  | 'StreamAdComplete'
  | 'StreamAdFilled'
  | 'StreamAdImpression'
  | 'StreamAdsFetchTimeout'
  | 'StreamChunklistFetch'
  | 'StreamAdChunklistResponse'
  | 'StreamError'
  | 'StreamPlaylistTimeout'
  | 'StreamPodRequest'
  | 'StreamStart';
export type StreamKPIDataKeys =
  | 'StreamAdFilled'
  | 'StreamPodRequest'
  | 'StreamPodFilled'
  | 'StreamAdImpression'
  | 'StreamChunklistFetch'
  | 'StreamChunklistResponse'
  | 'StreamStart';
export type StreamLatencyDataKeys =
  | 'StreamAdFilledLatency'
  | 'StreamAdFetchTimeout'
  | 'StreamPlaylistTimeout'
  | 'StreamChunklistTimeout';
export type StreamErrorDataKeys =
  | 'StreamTranscodeMissError'
  | 'StreamCachedAdMiss'
  | 'StreamAdsFetchError'
  | 'StreamPlaylistError'
  | 'StreamChunklistError'
  | 'StreamCacheReadMissError';

export type IStreamAggregateCardData = Record<StreamAggregateDataTitles, number>;

export type IStreamAggregateCardDataDisplay = Record<
  StreamAggregateDataTitles,
  IStreamDashboardCardDataDisplayItem
>;
export type IStreamKPICardDataDisplay = Record<
  StreamKPIDataTitles,
  IStreamDashboardCardDataDisplayItem
>;
export type IStreamLatencyCardDataDisplay = Record<
  StreamLatencyDataTitles,
  IStreamDashboardCardDataDisplayItem
>;
export type IStreamErrorCardDataDisplay = Record<
  StreamErrorDataTitles,
  IStreamDashboardCardDataDisplayItem
>;

export type StreamDashboardCardDataTitles =
  | StreamAggregateDataTitles
  | StreamKPIDataTitles
  | StreamLatencyDataTitles
  | StreamErrorDataTitles;
export type StreamDashboardCardDataKeys =
  | StreamAggregateDataKeys
  | StreamKPIDataKeys
  | StreamLatencyDataKeys
  | StreamErrorDataKeys;
export type StreamDashboardCardDataCompareKeys =
  | 'CompareAdsFilled'
  | 'ComparePodRequests'
  | 'CompareStreamError'
  | 'ComparePodsFilled'
  | 'CompareAdImpressions'
  | 'CompareAvgStreamAdFilledLatency'
  | 'CompareAdsFetchTimeout'
  | 'CompareStreamChunklistFetch'
  | 'CompareStreamAdChunklistResponse'
  | 'CompareStreamStart'
  | 'CompareStreamPlaylistTimeout';
